<template>
 <router-view />
</template>

<script>
export default {
  name:"Statistics"
}
</script>

<style>

</style>
